import { Fragment, type PropsWithChildren } from "react";

export interface TabbedViewPageProps {
    title: string;
    visible?: boolean;
}
export interface TabbedViewPageChild {
    props: TabbedViewPageProps;
}
const TabbedViewPage = (props: PropsWithChildren<TabbedViewPageProps>) => {
    if (props.visible == false) {
        return <Fragment></Fragment>
    }
    return <Fragment>{props.children}</Fragment>
}

export default TabbedViewPage;